// components/v2/common/ConfirmPhaseModal.jsx

const ConfirmPhaseModal = ({ show, stageName, isLoading, onConfirm, onCancel }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4 shadow-xl">
                <div className="flex items-center gap-3 mb-4">
                    <span className="material-icons text-amber-500 text-3xl">warning</span>
                    <h5 className="font-bold text-gray-800 mb-0">¿Forzar siguiente etapa?</h5>
                </div>
                <p className="text-sm text-gray-600 mb-6">
                    Estás a punto de marcar la etapa <strong>{stageName}</strong> como
                    completada manualmente. La fecha de hoy quedará registrada como fecha real
                    de cierre. <span className="text-red-500 font-bold">Esta acción no se puede deshacer.</span>
                </p>
                <div className="flex gap-3 justify-end">
                    <button
                        className="px-4 py-2 rounded-lg border border-gray-200 text-sm font-bold text-gray-600 hover:bg-gray-50"
                        onClick={onCancel}
                        disabled={isLoading}
                    >
                        Cancelar
                    </button>
                    <button
                        className="px-4 py-2 rounded-lg bg-amber-500 text-white text-sm font-bold hover:bg-amber-600 flex items-center gap-2 disabled:opacity-60"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading
                            ? <>
                                <span className="material-icons text-sm animate-spin">refresh</span>
                                Procesando...
                              </>
                            : <>
                                <span className="material-icons text-sm">fast_forward</span>
                                Sí, forzar etapa
                              </>
                        }
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmPhaseModal;